<template>
  <svg id="Icon_building" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 35.071 38.967">
    <g id="Icon_building-2" data-name="Icon_building">
      <path
        id="Path"
        d="M11.69,0A1.948,1.948,0,0,0,9.742,1.948V7.793H1.948A1.948,1.948,0,0,0,0,9.742V37.019a1.948,1.948,0,0,0,3.9,0V11.69h9.742V3.9h7.793V11.69h9.742V37.019a1.948,1.948,0,0,0,3.9,0V9.742a1.948,1.948,0,0,0-1.948-1.948H25.329V1.948A1.948,1.948,0,0,0,23.38,0Z"
        :fill="color"
      />
      <path
        id="Path-2"
        data-name="Path"
        d="M1.948,0A1.948,1.948,0,0,0,0,1.948V21.432a1.948,1.948,0,0,0,3.9,0V1.948A1.948,1.948,0,0,0,1.948,0Z"
        transform="translate(15.587 15.587)"
        :fill="color"
      />
      <path
        id="Path-3"
        data-name="Path"
        d="M1.948,0A1.948,1.948,0,0,0,0,1.948V17.535a1.948,1.948,0,0,0,3.9,0V1.948A1.948,1.948,0,0,0,1.948,0Z"
        transform="translate(7.793 19.484)"
        :fill="color"
      />
      <path
        id="Path-4"
        data-name="Path"
        d="M0,1.948a1.948,1.948,0,0,1,3.9,0V17.535a1.948,1.948,0,0,1-3.9,0Z"
        transform="translate(23.38 19.484)"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component } from "vue-property-decorator";
import AdminIconProto from "@/components/shared/icons/administration/AdminIconProto.vue";

@Component
export default class AdminIconOffices extends AdminIconProto {}
</script>

<style scoped>

</style>